import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DoctorMaleTwotoneStandard.js";
import c from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return a(c, n(e, {
    icon: d
  }), null);
};
o.displayName = "DoctorMaleTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
